export default "//pteglobalstatic.ptengine.com/pte/images/guide_video_cover_en.png"